const getUserSessionData = (sessionData) => sessionData.get('user');
const getClientSessionData = (sessionData) => sessionData.get('client');
const getTokenData = (sessionData) => sessionData.get('tokens');

export {getUserSessionData, getClientSessionData, getTokenData}